export var createOptions = function createOptions(dataTypes) {
  return dataTypes.map(function (dataType) {
    return {
      label: dataType.toLowerCase(),
      value: dataType
    };
  });
};